import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { LoadingApproved, LoadingRejected } from "pages/CheckList";
import { ChecklistAvulsoPrintingPage } from 'pages/CheckList/Printing';

const checklistRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'checklist',
  element: userBelongsToAnyOf('admin', 'warehouseMember', 'carrierMember', 'companyMember', 'checklistMember') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: 'avulsos-approved',
      element: <LoadingApproved />,
    },
    {
      path: 'avulsos-rejected',
      element: <LoadingRejected />,
    },
    {
      path: 'avulsos-print',
      element: <ChecklistAvulsoPrintingPage />,
    },
  ],
});

export default checklistRoutes;
